import { connect } from 'react-redux';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import Profile from './Profile';

const mapStateToProps = (state: { session: SessionState }) => ({
  userEmail: state.session.email,
  userLanguage: state.session.language,
});

export default connect(mapStateToProps, null)(Profile);
